import { render, staticRenderFns } from "./StakingHero.vue?vue&type=template&id=4aeb1430&scoped=true&"
import script from "./StakingHero.vue?vue&type=script&lang=js&"
export * from "./StakingHero.vue?vue&type=script&lang=js&"
import style0 from "./StakingHero.vue?vue&type=style&index=0&id=4aeb1430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb1430",
  null
  
)

export default component.exports